import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getMapTourDetailsById, getMapTours } from "../requests/map.services";

export function useTours(clickedTagValue, map) {

    let filters = { types: clickedTagValue?.map(tag => tag.type) }
    let queryParams = filters.types.length !== 0 ? JSON.stringify(filters) : null

    const { isFetchedAfterMount, isFetching, isError, error, data } = useQuery({
        queryKey: ['map-tours', clickedTagValue],
        queryFn: () => getMapTours(queryParams),
    });

    function customBounds(locationElements) {
        if (locationElements && locationElements.length > 1) {
            // find the first element depending on the element type
            const firstElement = locationElements[0];
            let boundaries = {
                leftLongitude: firstElement?.lng,
                rightLongitude: firstElement?.lng,
                botLatitude: firstElement?.lat,
                topLatitude: firstElement?.lat
            };
            for (let index = 0; index < locationElements.length; index++) {
                // get current element depending on the element type
                const element = locationElements[index];
                boundaries.leftLongitude = Math.min(boundaries.leftLongitude, element.lng);
                boundaries.rightLongitude = Math.max(boundaries.rightLongitude, element.lng);
                boundaries.botLatitude = Math.min(boundaries.botLatitude, element.lat);
                boundaries.topLatitude = Math.max(boundaries.topLatitude, element.lat);
            }
            return [[boundaries.topLatitude, boundaries.leftLongitude], [boundaries.botLatitude, boundaries.rightLongitude]];
        }
    }
    let locationMarkersBounds = useMemo(() => data?.length > 1 ? customBounds(data) : null, [data?.length])

    function mapFlyToTourBounds(locationMarkersBounds) {
        if (map && locationMarkersBounds) {
            map?.fitBounds(locationMarkersBounds)
        }
    }
    useMemo(() => mapFlyToTourBounds(locationMarkersBounds), [locationMarkersBounds])

    return { locationMarkersBounds, areToursFetchedAfterMount: isFetchedAfterMount, areToursFetching: isFetching, isError, mapTours: data, error };
}

export function useTourById(id) {

    const { isFetching, isError, error, data } = useQuery({
        queryKey: ['map-tour-id', id],
        queryFn: () => getMapTourDetailsById(id),
        refetchOnWindowFocus: false,
        enabled: Boolean(id),
    });

    return {
        isTourFetching: isFetching, isError, clickedTourData: data, error,
    };
}
